import 'tiny-slider/dist/tiny-slider.css';
import { tns } from 'tiny-slider/src/tiny-slider';

export const tinyslider = {
	init: () => {
		const tinySliders = document.querySelectorAll( '[data-tinyslider]' );
		tinySliders.forEach( ( elmt ) => {
			const options = JSON.parse( elmt.dataset.tinyslider );
			if ( ! options.hasOwnProperty( 'container' ) ) {
				options.container = elmt;
			}
			const controls = elmt.parentNode.querySelector( '.nav-controls' );
			if ( controls ) {
				const prevButton = controls.querySelector( '.prev' );
				if ( ! options.hasOwnProperty( 'prevButton' ) && prevButton ) {
					options.prevButton = prevButton;
				}
				const nextButton = controls.querySelector( '.next' );
				if ( ! options.hasOwnProperty( 'nextButton' ) && nextButton ) {
					options.nextButton = nextButton;
				}
				const dotsContainer = controls.querySelector( '.dots' );
				if ( ! options.hasOwnProperty( '.navContainer' ) && dotsContainer ) {
					options.navContainer = dotsContainer;
				}
			}
			tns( options );
		} );

		initSpecialSliders();
	},
};

function initSpecialSliders() {
	const adhesionCards = document.querySelector( '.adhesion-cards' );
	if ( adhesionCards ) {
		const navControls = document.createElement( 'div' );
		navControls.classList.add( 'nav-controls', 'style-light' );
		navControls.innerHTML = '<div class="prev"></div><div class="dots"></div><div class="next"></div>';
		adhesionCards.appendChild( navControls );
		const dotsContainer = navControls.querySelector( '.dots' );
		const sliderContainer = adhesionCards.querySelector( '.uagb-columns__inner-wrap' );
		const itemsCount = adhesionCards.querySelectorAll( '.uagb-columns__inner-wrap > .wp-block-uagb-column' ).length;
		for ( let i = 0; i < itemsCount; i++ ) {
			dotsContainer.innerHTML += '<div class="dot" style="display:none;"></div>';
		}
		tns( {
			container: sliderContainer,
			items: 1,
			navContainer: dotsContainer,
			prevButton: navControls.querySelector( '.prev' ),
			nextButton: navControls.querySelector( '.next' ),
			responsive: {
				768: {
					items: 99,
					disable: true,
				}
			}
		} );
	}
}